import { styled, Box, Typography } from "@mui/material";
import { addDays, intervalToDuration, startOfDay } from "date-fns";

import { StatusBgMap } from "~/utils/statuses";
import { datef, formatInterval } from "@caredna-marlin/utils/dates";

import { ShiftStatusEnum } from "~/graphql/__generated__/graphql";

import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import { LocalShift } from "~/hooks/visitDragDropReducer";

type ShiftEventProps = {
  date: Date;
  shift: LocalShift;
  titleContent?: string;
  utilization?: number;
  centerpointName?: string;
  overflowShift?: boolean;
};

const CustomContainer = styled("div")`
  width: 100%;
  height: 40px;
  position: relative;
`;

const ShiftEvent: React.FC<ShiftEventProps> = ({ date, shift, titleContent, utilization, centerpointName, overflowShift }) => {
  const start = new Date(shift.startTime);
  const end = new Date(shift.endTime);
  const eventStatus = shift.status;

  const duration = (end && start) ? intervalToDuration({ start, end }) : {};

  // Partly transparent "canceled" color
  const canceled = StatusBgMap.canceled + '44';
  const background = eventStatus === ShiftStatusEnum["Confirmed"] ? "#F8F8F8" : `repeating-linear-gradient(-45deg, #fff, #fff 11px, ${canceled} 11px, ${canceled} 22px)`;

  return (
    <CustomContainer>
      <Box sx={{
        color: "black",
        cursor: "pointer",
        background,
        textAlign: "left",
        marginTop: "5px",
        padding: "2px 2px 2px 8px",
        fontSize: "10.5px",
        fontWeight: 400,
        minHeight: "20px",
        display: "flex",
        alignItems: "center",
        textOverflow: "ellipsis",
        overflow: "hidden",
        border: "1px dotted grey",
      }}
      >
        {start < startOfDay(date) && <Typography
          variant="body2"
          component="span"
          sx={{ fontWeight: "normal", mr: 3 }}
        >
          {"« "}{datef(start, "MMM d")}
        </Typography>}
        <Typography
          variant="body2"
          component="span"
          sx={{ fontWeight: "normal", mr: 1 }}
        >
          {titleContent}
        </Typography>
        <Typography variant="body2" component="span" sx={{ textTransform: 'none', mr: 1 }}>
          {" - "}{formatInterval(duration)} {utilization ? `(${utilization}% utilization)` : null}
        </Typography>
        {
          centerpointName ? (
            <>
              <GpsFixedIcon fontSize="small" sx={{mr: 0.5}} />
              <Typography variant="body2" component="span" sx={{ textTransform: 'none', mr: 1 }}>
                {centerpointName}
              </Typography>
            </>
          ) : null
        }
        {
          overflowShift ? (
            <Typography variant="body2" component="span" sx={{ textTransform: 'none', mr: 1 }}>
              OVERFLOW SHIFT
            </Typography>
          ) : null
        }
        {end > addDays(startOfDay(date), 1) && <Typography
          variant="body2"
          component="span"
          sx={{ fontWeight: "normal", ml: 3 }}
        >
          {datef(end, "MMM d")}{" »"}
        </Typography>}
      </Box>
    </CustomContainer>
  );
};

export default ShiftEvent;
